export default __webpack_public_path__ + "static/media/790895058257051657.52208302.png";